<template>
  <div>
    <add-new-memb
      v-if="!showCglModal"
      :options="addNewMembOptions"
      @token="getToken"
      @ingenicoCheck="nextStep"
    >
    </add-new-memb>

    <!-- 不适用弹窗模式 -->
    <congratulations v-if="showCglModal" :cardData="cardData">
      <template #head>
        <div class="cgl">
          <p class="dpi-success">{{ $t('msg-congratulations') }}</p>
        </div>
      </template>
    </congratulations>
    <!-- <MsgModal
      :componentShow="componentShow"
      :options="messageModalOptions"
      @confirm="handleMsgConfirm"
    ></MsgModal> -->

    <!-- 添加成功后展示的弹窗 -->
    <!-- <congratulations-modal :showDialogModal="showCglModal" @show="handleCglClick">
      <template #content>
        <congratulations :options="cglsOpitions" :cardData="cardData"> </congratulations>
      </template>
    </congratulations-modal> -->
  </div>
</template>

<script>
  import AddNewMemb from '../SignUp/componets/Step1/index.vue';
  import Congratulations from '../SignUp/componets/Step4';
  import CongratulationsModal from '@/components/BaseUi/DialogModal';
  // import { handleCreateSession } from '@/utils/createSession';
  import { formatCardNo } from '@/components/BaseUi/Form/utils/index';
  import { mapMutations, mapState } from 'vuex';
  // import MsgModal from '@/components/BaseUi/MessageModal/src/index.vue';
  const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));

  export default {
    name: 'AddNewMembership',

    components: {
      AddNewMemb,
      Congratulations,
      CongratulationsModal,
      // MsgModal,
    },

    mounted() {
      // this.$messageModal.show(this.messageModalOptions);
    },

    data() {
      return {
        // componentShow: false,
        token: '',
        cardHolderName: '',
        showCglModal: false,
        cardData: {},
        cardInfoToken: '',
        addNewMembOptions: {
          title: 'add-new-mbs-title',
          source: 2, // 加卡
        },
        messageModalOptions: {
          image: false,
          // descGroup: {
          //   desc1: 'mayHave',
          //   desc2: 'reEntering',
          //   subDesc: ['have1', 'have2', 'have3'],
          // },
          descGroup: {
            desc1: 'mayHave',
            desc2: 'reEntering',
            subDesc: ['have1', 'have2', 'have3'],
          },
          confirmBtn: 'ok',
          justHide: true,
        },
        // cglsOpitions: {
        // descShow: false,
        // title: this.$i18n.t('msg-congratulations'),
        // userCglsModalClass: true,
        // },
      };
    },

    methods: {
      handleMsgConfirm() {
        this.componentShow = false;
      },
      handleCglClick(data = true) {
        this.showCglModal = Boolean(data);
      },

      getToken(token) {
        this.token = token;
      },

      nextStep(value) {
        console.log('value', value);
        this.cardHolderName = value.visaCardName;
        this.cardInfoToken = value.cardInfoToken;
        this.bindVisaCard(value.paymentHash);
        // handleCreateSession(value, this.bindVisaCard);
      },

      // 绑定新的会员卡
      bindVisaCard(paymentHash = '') {
        const { userId, sessionId } = this.userInfo;

        const data = {
          userId,
          token: this.token,
          encryptCustomerInput: paymentHash,
          lang: this.$i18n.locale,
          cardHolderName: this.cardHolderName,
          sessionId,
          cardInfoToken: this.cardInfoToken,
        };

        this.$http.member
          .bindVisaCard(data)
          .then(res => {
            if (res.state === '11') {
              const dragonCardData = {
                lang: this.$i18n.locale,
                device: 'web',
                version: '1.0.0',
                userId,
                sessionId,
                deviceName,
              };
              // 获取龙腾卡号
              this.getDragonCard(dragonCardData).then(res => {
                const { bankLogo, bankLogoThumbnails, englishName, dragoncode, cardValidDate } =
                  res.card;
                const formatDragoncode = formatCardNo(dragoncode);
                this.cardData = {
                  bankLogo,
                  bankLogoThumbnails,
                  englishName,
                  dragoncode: formatDragoncode,
                  cardValidDate,
                };
                this.handleCglClick();
              });
            } else if (res.state === '00' && res?.errorCode === 'visa.card.ingenico.fail') {
              // this.componentShow = true;
              this.$messageModal.show({
                image: false,
                descGroup: {
                  desc1: 'mayHave',
                  desc2: 'reEntering',
                  subDesc: ['have1', 'have2', 'have3'],
                },
                confirmBtn: 'ok',
                justHide: true,
              });
              return;
            } else if (res.state === '00') {
              this.$loading.hide();
              res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
            }
          })
          .catch(error => {
            console.error(error);
          });
      },

      // 获取龙腾卡信息
      getDragonCard(data) {
        return new Promise(resolve => {
          this.$http.login.getDragonCard(data).then(
            res => {
              if (res.state === '11') {
                resolve(res);
              } else if (res.state === '00') {
                res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
              }
            },
            err => {
              console.error(err);
              this.$loading.hide();
            },
          );
        });
      },

      ...mapMutations(['showMessageModal']),
    },

    computed: {
      ...mapState(['userInfo']),
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
